import axios from "axios";

// Python backend — used by pages not yet migrated to NestJS
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("humrahe_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// NestJS backend — used by rahe-portal modules
export const nestApi = axios.create({
  baseURL: process.env.REACT_APP_NESTJS_URL,
});

nestApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("humrahe_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
